import { RefObject, useEffect, useMemo, useState } from 'react';

export const useInView = (
	ref: RefObject<HTMLElement>,
	intersectionOptions?: IntersectionObserverInit & { triggerOnce?: boolean },
) => {
	const [isIntersecting, setIntersecting] = useState(false);

	const observer = useMemo(
		() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), intersectionOptions),
		[intersectionOptions],
	);

	useEffect(() => {
		observer.observe(ref.current as HTMLElement);

		if (intersectionOptions?.triggerOnce && isIntersecting) {
			observer.disconnect();
		}

		return () => observer.disconnect();
	}, [observer, ref, isIntersecting, intersectionOptions]);

	return isIntersecting;
};
